// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sctaPage>div[data-v-6e4634e6]{font-size:.8rem;line-height:2;text-align:center}@media(min-width:768px){.sctaPage>div[data-v-6e4634e6]{font-size:1rem}}.sctaPage>div p[data-v-6e4634e6]{display:inline-block;text-align:left}.sctaPage>ul[data-v-6e4634e6]{margin-top:1rem}@media(min-width:768px){.sctaPage>ul[data-v-6e4634e6]{margin-top:2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
